import HomeRoutes from './HomeRoutes'

export default HomeRoutes
